/*
 * @Descripttion: 数据详情
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, {useContext} from 'react';
import {Radio, Balloon, Icon} from '@alifd/next';
import {ActivityContext} from '../../index';
import CONSTANTS from '../CONSTANTS';
import utils from '@/common/utils';
import styles from './index.module.scss';

const { Tooltip } = Balloon;

const DataInfo = () => {
  const {ratioTime, changeROITime, panelInfo, setChangePriceDialog} = useContext(ActivityContext);
  return (
    <div className={styles['data-info-container']}>

      <div className={styles['line-container']}>
        <div className={styles['one-line']}>
          <div className={styles.across}></div>
          <div className={styles['one-content']}>
            <div className={styles.wd}>触达率：{panelInfo.sendRate}</div>
          </div>
        </div>
        <div className={styles['two-line']}>
          <div className={styles.across}></div>
          <div className={styles['two-content']}>
            <div className={styles.wd}>访问率：{panelInfo.recallUserCntRate}</div>
          </div>
          <div className={styles.across}></div>
        </div>
        <div className={styles['three-line']}>
          <div className={styles['three-content']}>
            <div className={styles.wd}>访问转化率：{panelInfo.recallOrderUserCntRate}</div>
          </div>
          <div className={styles.across}></div>
        </div>
      </div>

      <div className={styles['shape-container']}>
        <div className={styles['one-container']}>
          <div className={styles.content}>预计触达人数/人：{utils.numFormat(panelInfo.prepNum)}</div>
          <div className={styles.time}>24h</div>
        </div>
        <div className={styles['two-container']}>
          <div className={styles.content}>实际触达人数/人：{utils.numFormat(panelInfo.actualNum)}</div>
          <div className={styles.time}>24h</div>
        </div>
        <div className={styles['three-container']}>
          <div className={styles.content}>访问人数/人：{utils.numFormat(panelInfo.recallUserCnt)}</div>
          <div className={styles.time}>24h</div>
        </div>
        <div className={styles['four-container']}>
          <div className={styles.content}>付款人数/人：{utils.numFormat(panelInfo.orderUserCnt)}</div>
          <div className={styles.time}>{ratioTime}天</div>
        </div>
      </div>

      <div className={styles['right-container']}>
        <div className={styles['one-container']}>
          <div className={styles['one-content']}>
            <div className={styles.title} style={{marginBottom: 30}}>触达数据 <span className={styles.desc}>本短信任务的发送数据</span></div>
            <div className={styles['display-flex']}>
              <div>
                <div>预计触达人数/人</div>
                <div className={styles.vals}>{utils.numFormat(panelInfo.prepNum)}</div>
              </div>
              <div>
                <div>预计花费短信/人</div>
                <div className={styles.vals}>{utils.numFormat(panelInfo.prepSmsNum)}</div>
              </div>
              <div>
                <div>实际触达人数/人</div>
                <div className={styles.vals}>{utils.numFormat(panelInfo.actualNum)}</div>
              </div>
              <div>
                <div>实际花费短信/人</div>
                <div className={styles.vals}>{utils.numFormat(panelInfo.actualSmsNum)}</div>
              </div>
              <div>
                <div className={styles['flex-column']}>
                  触达率
                  <Tooltip v2 trigger={<Icon type="help" size={'small'} />} align="t">
                    {CONSTANTS.sendRate}
                  </Tooltip>
                </div>
                <div className={styles.vals}>{panelInfo.sendRate}</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles['two-container']}>
          <div className={styles['two-content']}>
            <div className={styles.title}>
              <span>访问数据</span>
              <span className={styles.desc}>本短信任务触达用户24h内的访问数据</span>
              <span className={styles.desc} style={{color: 'red'}}>目前抖音平台仅支持24h内的数据</span>
              <div className={styles.desc}>
                <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
                访问人群：收到短信的用户<span style={{color: 'red'}}>24h内</span>在店铺账号主页/会员中心/商详/订单页/购物车页面/券红包有访问行为人群
              </div>
            </div>
            <div className={styles['display-flex']} style={{justifyContent: 'start'}}>
              <div style={{marginRight: 20}}>
                <div>访问人数/人</div>
                <div className={styles.vals}>{utils.numFormat(panelInfo.recallUserCnt)}</div>
              </div>
              <div className={styles['flex-column']}>
                <div>
                  访问率
                  <Tooltip v2 trigger={<Icon type="help" size={'small'} />} align="t">
                    {CONSTANTS.recallUserCntRate}
                  </Tooltip>
                </div>
                <div className={styles.vals}>{utils.numFormat(panelInfo.recallUserCntRate)}</div>
              </div>
            </div>
          </div>
        </div>
        <div style={{margin: '20px 0 5px 0', textAlign: 'right'}}>
          <Radio.Group
            size='small'
            shape="button"
            dataSource={CONSTANTS.Tab_List}
            value={ratioTime}
            onChange={changeROITime}
            // className="market-effect-radio-group-tab"
          />
        </div>
        <div className={styles['three-container']}>
          <div className={styles['three-content']}>
            <div className={styles.title}>
              <span>转化数据</span>
              <span className={styles.desc}>本短信任务触达用户的交易数据</span>
              <br />
              <div className={styles.desc}>
                <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
                收到短信的用户<span style={{color: 'red'}}>{ratioTime}天内</span>在本店的成交数据
              </div>
            </div>
            <div className={styles['display-flex']}>
              <div>
                <div>成交人数/人</div>
                <div className={styles.vals}>{utils.numFormat(panelInfo.orderUserCnt)}</div>
              </div>
              <div>
                <div>成交金额/元</div>
                <div className={styles.vals}>{utils.numFormat(panelInfo.orderAmt)}</div>
              </div>
              <div>
                <div className={styles['flex-column']}>
                  客单价（元/人）
                  <Tooltip v2 trigger={<Icon type="help" size={'small'} />} align="t">
                    {CONSTANTS.kedan}
                  </Tooltip>
                </div>
                <div className={styles.vals}>{utils.numFormat(panelInfo.perOrderUserAmt)}</div>
              </div>
              <div>
                <div className={styles['flex-column']}>
                  访问转化率
                  <Tooltip v2 trigger={<Icon type="help" size={'small'} />} align="t">
                    {CONSTANTS.fangwenzhuanhua}
                  </Tooltip>
                </div>
                <div className={styles.vals}>{panelInfo.recallOrderUserCntRate}</div>
              </div>
              <div>
                <div className={styles['flex-column']}>
                  触达转化率
                  <Tooltip v2 trigger={<Icon type="help" size={'small'} />} align="t">
                    {CONSTANTS.chudazhuanhua}
                  </Tooltip>
                </div>
                <div className={styles.vals}>{panelInfo.orderUserCntRate}</div>
              </div>
              <div>
                <div>
                  ROI
                  <Tooltip v2 trigger={<Icon type="help" size={'small'} />} align="t">
                    {CONSTANTS.ROI}
                  </Tooltip>
                </div>
                <div className={styles.vals}>
                  {panelInfo.roi}
                  <span className={styles['btn-span']} onClick={() => setChangePriceDialog(true)}>修改</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default DataInfo;
